export default () => (
  <svg width='32px' height='32px' viewBox='0 0 32 32'>
    <g id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'>
      <g id='zendesk-logo' fill-rule='nonzero'>
        <rect id='Rectangle-path' fill='#04363F' x='0' y='0' width='32' height='32' rx='2' />
        <polygon id='Shape' fill='#FFFFFF' points='15.1625 11.9101 15.1625 24.17055 5 24.17055' />
        <path d='M15.16275,7.50565 C15.16275,10.3085 12.89,12.5869 10.0815,12.58125 C7.2786,12.58125 5.00025,10.3085 5.0058397,7.5 L15.16275,7.50565 Z' id='Shape' fill='#FFFFFF' />
        <path d='M16.83185,24.17615 C16.83185,21.3733 19.11025,19.0949 21.9131,19.10055 C24.716,19.10055 26.99435,21.3733 26.9887603,24.1818 L16.83185,24.17615 Z' id='Shape' fill='#FFFFFF' />
        <polygon id='Shape' fill='#FFFFFF' points='16.8375 19.77175 16.8375 7.5057 27 7.5113' />
      </g>
    </g>
  </svg>
)
